module.exports = __webpack_public_path__ + "media/tân sà-maa-chík.c383a8d5.mp3";